import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1875 6.20644H10.7441V12.8139C10.7441 12.8998 10.6738 12.9701 10.5879 12.9701H9.41602C9.33008 12.9701 9.25977 12.8998 9.25977 12.8139V6.20644H7.8125C7.68164 6.20644 7.60938 6.05604 7.68945 5.95448L9.87695 3.18495C9.89157 3.16628 9.91024 3.15117 9.93156 3.14079C9.95288 3.1304 9.97629 3.125 10 3.125C10.0237 3.125 10.0471 3.1304 10.0684 3.14079C10.0898 3.15117 10.1084 3.16628 10.123 3.18495L12.3105 5.95253C12.3906 6.05605 12.3184 6.20644 12.1875 6.20644V6.20644ZM2.85156 12.2279H4.02344C4.10938 12.2279 4.17969 12.2982 4.17969 12.3842V15.392H15.8203V12.3842C15.8203 12.2982 15.8906 12.2279 15.9766 12.2279H17.1484C17.2344 12.2279 17.3047 12.2982 17.3047 12.3842V16.2514C17.3047 16.5971 17.0254 16.8764 16.6797 16.8764H3.32031C2.97461 16.8764 2.69531 16.5971 2.69531 16.2514V12.3842C2.69531 12.2982 2.76562 12.2279 2.85156 12.2279Z"
        fill={fill}
      />
    </svg>
  );
};

export default memo(Icon);
